import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Card, CardBody, Label, Button, UncontrolledTooltip } from 'reactstrap';
import { Form, Field, FormGroup } from '@availity/form';
import '@availity/yup';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import ProgressBar from '../../Common/components/ProgressBar';
import qualityStore from '../stores/QualityStore';

@observer
export default class PreparerInfo extends Component {
  constructor(props) {
    super(props);
    if (qualityStore.getPageStatus('#preparerinfo') !== 'stepwizard-step active') {
      qualityStore.setPageStatus('#preparerinfo', 'active');
    }
  }

  setFirstName = event => {
    const { value } = event.target;
    qualityStore.updateRepFirst(value);
  }

  setLastName = event => {
    const { value } = event.target;
    qualityStore.updateRepLast(value);
  }

  setPreparerOrg = event => {
    const { value } = event.target;
    qualityStore.updateRepOrg(value);
  }

  setDepartment = event => {
    const { value } = event.target;
    qualityStore.updateRepDept(value);
  }

  setJobTitle = event => {
    const { value } = event.target;
    qualityStore.updateRepJobTitle(value);
  }

  setPreparerPhone = event => {
    const { value } = event.target;
    qualityStore.updateRepPhone(value);
  }

  setHealthyBlueMemberValue = event => {
    qualityStore.updateHealthyBlueMember(event.target.value);
  }

  submit = () => {
    const { history } = this.props;
    history.push('/memberinfo');
  }

  render() {
    const {
      stateCode,
      firstName,
      lastName,
      preparerOrg,
      department,
      jobTitle,
      datetoDisplay,
      displayPhone
    } = qualityStore;

    const preparerOrgReq = jobTitle !== '' || department !== '';
    const departmentReq = preparerOrg !== '' || jobTitle !== '';
    const jobTitleReq = preparerOrg !== '' || department !== '';

    return (
      <Card>
        <CardBody className="p-40">
          <ProgressBar />
          <div className="border-form">
            <Form
              onSubmit={this.submit}
              initialValues={{
                preparerFirst: firstName,
                preparerLast: lastName,
                preparerOrganization: preparerOrg,
                preparerDepartment: department,
                preparerTitle: jobTitle,
                PreparerPhone: displayPhone,
              }}
              validationSchema={yup.object().shape({
                preparerFirst: yup
                  .string()
                  .required('Preparer First Name is required!')
                  .matches(/^[A-Za-z]+[ ',.A-Za-z-]*[ A-Za-z]$/, 'Preparer First Name should start and end with a letter.'),
                preparerLast: yup
                  .string()
                  .required('Preparer Last Name is required!')
                  .matches(/^[A-Za-z]+[ ',.A-Za-z-]*[ A-Za-z]$/, 'Preparer Last Name should start and end with a letter.'),
                preparerOrganization:
                  yup
                    .string()
                    .isRequired(preparerOrgReq, 'Preparer Organization is required!')
                    .matches(/^[A-Za-z]+[ ',.A-Za-z-]*[ A-Za-z]$/, 'Preparer Organization should start and end with a letter.'),
                preparerDepartment:
                  yup
                    .string()
                    .isRequired(departmentReq, 'Preparer Department is required!')
                    .matches(/^[A-Za-z]+[ ',.A-Za-z-]*[ A-Za-z]$/, 'Preparer Department should start and end with a letter.'),
                preparerTitle:
                  yup
                    .string()
                    .isRequired(jobTitleReq, 'Preparer Job Title is required!')
                    .matches(/^[A-Za-z]+[ ',.A-Za-z-]*[ A-Za-z]$/, 'Preparer Job Title should start and end with a letter.'),
                PreparerPhone: yup
                  .string()
                  .min(10, 'Phone number must be at least 10 digits')
                  .matches(/^\d{10}(-\d{1,10})?$/, 'Phone Number/Extension is incorrect or incomplete, please enter correct Phone Number/Extension and please include "-"(hyphen) for Extension')
                  .required('Phone Number is required!'),
              })}
            >
              {
                stateCode === 'NC' ?
                  <p>
                    <b>This application is for Medicaid Members Only</b>
                  </p>
                  :
                  null
              }
              <h2 className="primarycardTitle">
                <b>Preparer Information</b>
              </h2>

              <div className="titleSpacer" />

              <p>{`Asterisks (*) mark required fields`}</p>

              <div className='spacer' />

              <Row>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="preparerFirst">
                    <Label for="preparerFirst">
                      First Name*
                    </Label>
                    <Field
                      type="text"
                      id="preparerFirst"
                      name="preparerFirst"
                      value={firstName}
                      onChange={this.setFirstName}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="preparerLast">
                    <Label for="preparerLast">
                      Last Name*
                    </Label>
                    <Field
                      type="text"
                      id="preparerLast"
                      name="preparerLast"
                      value={lastName}
                      onChange={this.setLastName}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="preparerOrganization">
                    <Label for="preparerOrganization">
                      {(jobTitle !== '' || department !== '' || preparerOrg !== '') ?
                        'Organization (Reporting on behalf of an Organization)*'
                        : 'Organization (Reporting on behalf of an Organization)'}
                    </Label>
                    <Field
                      type="text"
                      id="preparerOrganization"
                      name="preparerOrganization"
                      value={preparerOrg}
                      onChange={this.setPreparerOrg}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="preparerDepartment">
                    <Label for="preparerDepartment">
                      {(preparerOrg !== '' || jobTitle !== '' || department !== '') ? 'Department*' : 'Department'}
                    </Label>
                    <Field
                      type="text"
                      id="preparerDepartment"
                      name="preparerDepartment"
                      value={department}
                      onChange={this.setDepartment}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="preparerTitle">
                    <Label for="preparerTitle">
                      {(preparerOrg !== '' || department !== '' || jobTitle !== '') ? 'Job Title*' : 'Job Title'}
                    </Label>
                    <Field
                      type="text"
                      id="preparerTitle"
                      name="preparerTitle"
                      value={jobTitle}
                      onChange={this.setJobTitle}
                      maxLength={25}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="PreparerPhone">
                    <Label id="preparerPhoneLabel" for="PreparerPhone">
                      {'Phone Number & Ext*'}
                      <span id="preparerPhone-help" className="inline-help" />
                    </Label>
                    <UncontrolledTooltip target="preparerPhoneLabel" placement="right"
                      innerClassName="text-left">
                      {`Phone Number & Extension format: 0123456789-0123456789; must include "-"(hyphen) for Extension`}
                    </UncontrolledTooltip>
                    <Field
                      type="text"
                      id="PreparerPhone"
                      name="PreparerPhone"
                      value={displayPhone}
                      placeholder='0123456789-0123456789'
                      onChange={this.setPreparerPhone}
                      maxLength={21}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="6" sm="3">
                  <FormGroup for="dateofReport" className="mb-50">
                    <Label for="dateofReport">
                      Date of Report
                    </Label>
                    <Field
                      type="text"
                      id="dateofReport"
                      name="dateofReport"
                      value={datetoDisplay}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Button type="submit" color={"primary"} className={'btn btn-primary nextBtn'}>
                Next
              </Button>
            </Form>
          </div>
        </CardBody>
      </Card >
    );
  }
}

PreparerInfo.propTypes = {
  history: PropTypes.object
};
